import React from "react";
import { Modal, Icon, List, Divider } from "antd";
import { useTranslation } from "react-i18next";

import BundleCardHolder from "../../../Styles/bundleCardStyle";
import NumberFormat from "../../../NumberFormat";
import { truncateText } from "../../../../services/display";
import { BundleSvg } from "../../../../images/customIcons/BundleSvg";
import Colors from "../../../../themes/Colors";

// Same member filtering BundleCardComponent applies: a programmatic campaign only
// takes the smart-campaign screens, a traditional one only the published ones.
const getBundleDisplays = (bundle, programmatic) => {
  const displays = bundle.displays || [];

  if (programmatic === "programmatic") {
    return displays.filter((display) => display.smart_campaign_enabled);
  }
  if (programmatic === "traditional") {
    return displays.filter((display) => display.published);
  }
  return displays;
};

/**
 * Shown after a bulk selection that pulled in `bundle_only` screens: lists the
 * sales bundles that were added to the cart with all of their screens, with the
 * same detail as BundleCardComponent (no map, no CPM range, no actions).
 */
function BundlesAddedModal({ visible, bundles, programmatic, currency, onClose }) {
  const { t } = useTranslation();
  const total = (bundles || []).length;

  return (
    <Modal
      title={
        <span>
          {/* BundleSvg ignores the width/height antd passes it, so the size has
              to come from this wrapper — the inner svg then fills it. */}
          <Icon
            component={BundleSvg}
            style={{ width: 22, height: 22, marginRight: 8, verticalAlign: -4 }}
          />
          {/* The key is picked by hand instead of relying on i18next's `count`
              pluralization: there's no plural rule for the `es_ar` language code,
              so it would always resolve to the singular there. */}
          {total === 1
            ? t("{{total}} sales bundle added", { total })
            : t("{{total}} sales bundles added", { total })}
        </span>
      }
      visible={visible}
      onCancel={onClose}
      onOk={onClose}
      okText={t("Confirm")}
      cancelButtonProps={{ style: { display: "none" } }}
      bodyStyle={{ maxHeight: "60vh", overflowY: "auto" }}
    >
      <BundleCardHolder>
        <div style={{ padding: "16px 16px" }}>
          <p>
            {t(
              "The following sales bundles were added with all of their screens.",
            )}
          </p>

          {(bundles || []).map((bundle, index) => {
            const bundleDisplays = getBundleDisplays(bundle, programmatic);

            return (
              <div key={bundle.id}>
                {index > 0 ? <Divider /> : null}

                <span className="titleBundle screenCardContent bundleIcon">
                  <Icon
                    component={BundleSvg}
                    style={{ width: 26, height: 26, marginRight: 10 }}
                  />
                  <h2>{bundle.name} ({bundleDisplays.length})</h2>
                </span>
                <List
                  bordered={false}
                  className="listDisplays"
                  dataSource={bundleDisplays}
                  renderItem={(item) => (
                    <List.Item key={item.id}>
                      {truncateText(item.name, 25)}
                      <a
                        className="link"
                        style={{ marginLeft: "5px" }}
                        href={`/screen/${item.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Icon type="link" />
                      </a>
                    </List.Item>
                  )}
                />
              </div>
            );
          })}
        </div>
      </BundleCardHolder>
    </Modal>
  );
}

export default BundlesAddedModal;
